import { render, staticRenderFns } from "./RenewAffiliate.vue?vue&type=template&id=2c43816b"
import script from "./RenewAffiliate.vue?vue&type=script&lang=ts"
export * from "./RenewAffiliate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports